module.exports = __webpack_public_path__ + "assets/img/8b7fdea1dd976ca46b59b876bc04ded2.png";